export const projects = [
  {
    "title": "Portfolio Website",
    "subtitle": "React, Tailwind CSS, Framer Motion",
    "description": "A modern, responsive portfolio website showcasing my professional experience and projects. Features include smooth animations using Framer Motion, a clean UI developed with Tailwind CSS, and interactive components like an accordion-style work history section. The site demonstrates modern web development practices and responsive design principles.",
    "image": "./portfolio.png",
    "link": "https://connorflynn-portfolio.netlify.app/",
    "gitlink": "https://github.com/connorflynn4/my-portfolio",
    "hostlink": "https://connorflynn-portfolio.netlify.app/"
  },
  {
    "title": "North Architecture",
    "subtitle": "Next.js, TypeScript, Tailwind CSS, shadcn/ui, Biome, Turbopack",
    "description": "A modern architectural portfolio website showcasing luxury residential and hospitality projects. Features include responsive image galleries, project case studies with detailed information, and a clean, minimalist design. The site demonstrates modern web development practices with Next.js for optimal performance, TypeScript for type safety, and Tailwind CSS for responsive design.",
    "image": "./north-architecture.png",
    "link": "https://north-architecture.vercel.app/",
    "gitlink": "https://github.com/connorflynn4/north-architecture",
    "hostlink": "https://north-architecture.vercel.app/"
},
  {
    "title": "Cryptocurrency Information App",
    "subtitle": "Vite, React, TypeScript, Tailwind CSS, Netlify",
    "description": "A modern cryptocurrency tracking app providing real-time data on various cryptocurrencies. Features include interactive price history charts, and a dynamic UI developed with Tailwind CSS. The app fetches data from multiple APIs using RapidAPI and is continuously deployed on Netlify.",
    "image": "./crypto-info.png",
    "link": "https://crypto-information-app.netlify.app/",
    "gitlink": "https://github.com/connorflynn4/crypto-information",
    "hostlink": "https://crypto-information-app.netlify.app/"
  },
  {
    title: "AI Article Summarizer",
    subtitle: "React, Vite, Redux-Toolkit, Tailwind CSS, Local Storage",
    description:
      "This application is built using ReactJS and Vite, and it focuses on creating a responsive UI/UX with a glass morphism design using Tailwind CSS. It utilizes advanced RTK query API requests, which are conditionally triggered. The application also incorporates local storage for saving history, handles form events, catches errors, and implements a copy-to-clipboard functionality. Throughout the development process, emphasis is placed on writing clean and maintainable code.",
    image: "./ai_sum.png",
    link: "https://ai-article-summarizer-application.netlify.app/",
    gitlink: "https://github.com/connorflynn4/ai-summarizer",
    hostlink: "https://ai-article-summarizer-application.netlify.app/",
  },
  {
    title: "Coordinates Generator",
    subtitle: "HTML, CSS, JavaScript, Leaflet, Nominatim (OpenStreetMap)",
    description:
      "The Coordinates Generator is a web application that allows users to interactively select geographical points on a map, view their corresponding latitude and longitude values, and manage these coordinates efficiently.",
    image: "./coordgen.png",
    link: "https://connorflynn4.github.io/coordinates-generator/",
    gitlink: "https://github.com/connorflynn4/coordinates-generator",
    hostlink: "https://connorflynn4.github.io/coordinates-generator/",
  },
  
  {
    title: "AI Task Organizer",
    subtitle: "Next.js 13.4, GPT-4, Drag & Drop, Zustand, Appwrite Cloud, TS",
    description:
    "This application is built with Next.js 13.4 and Zustand, it aims to provide a task management solution. It incorporates GPT-4 for intelligent task insights and drag-and-drop features for easy task organization. It leverages Appwrite Cloud for secure backend services and it's developed using TypeScript, the app emphasizes clean, maintainable code for reliable task management",    
    image: "./ai_task_org.png",
    link: "https://ai-task-organizer.vercel.app/",
    gitlink: "https://github.com/connorflynn4/ai-task-organizer",
    hostlink: "https://ai-task-organizer.vercel.app/",
  },
  
  {
    title: "OMDB Movie App",
    subtitle: "React, React Router, React Hooks, Reactstrap, Node.js, OMDB API & Netlify",
    description:
      "The OMDB Movie Search App is a React-based web application that allows users to search for movies and view detailed information about each movie. Utilizing the OMDB API, users can search for movies by title and receive a list of matching results. Users can click on a 'View Movie' button to navigate to a detailed page that provides an in-depth overview of the selected movie, including its plot, genre, director, actors, and IMDB rating. Linked to GitHub and uses Netlify for continuous deployment",
    image: "./omdb-movie.png",
    link: "https://omdb-movie-app-portfolio.netlify.app/",
    gitlink: "https://github.com/connorflynn4/omdb-movie-app",
    hostlink: "https://omdb-movie-app-portfolio.netlify.app/",
  },
  {
    title: "Hulu Clone",
    subtitle: "React, Next.js, Tailwind CSS, Flexbox, CSS Grid & Vercel",
    description:
      "A Hulu clone React app that consumes the TMDb API, this app uses Next.js to implement server-side rendering. Users have the ability to filter through movies based on their category.",
    image: "./hulu-clone.png",
    link: "https://hulu-app-clone.vercel.app/",
    gitlink: "https://github.com/connorflynn4/hulu-clone",
    hostlink: "https://hulu-app-clone.vercel.app/",
  },
];

export const skills = [
  "Python (Flask, Scrapy, Selenium)",
  "JavaScript/TypeScript (Node, Express, React)",
  "C#",
  "HTML/CSS/SASS/Tailwind CSS",
  "Rest APIs",
  "Mapbox GL",
  "GPT-4",
  "Docker",
  "WordPress/Shopify",
  "Vercel, Heroku, Netlify",
  "Firebase, Mongo, SQL"
];

export const workHistory = [
  {
    company: "ChainXY",
    location: "Vancouver, BC",
    positions: [
      {
        title: "Software Developer Lead",
        period: "May 2022 – Present",
        description: [
          "Pioneered a system that allows web scraping automation through ChatGPT, enabling dynamic interaction with scraping scripts, significantly reducing manual intervention.",
          "Led the resolution of critical performance bugs in the user platform, coordinating with the QA team to streamline bug tracking, delegation, and timeline estimation using Asana.",
          "Rewrote key data pipeline components that were originally implemented with blocking synchronous code, converting them to asynchronous code using Python's 'asyncio' library. This transition significantly improved the pipeline's efficiency and scalability, reducing processing time by over 30%."
        ],
        technologies: ["Python", "React.js", "JavaScript", "C#", ".NET", "Docker", "ChatGPT", "Asana"]
      },
      {
        title: "Software Developer",
        period: "November 2019 – May 2022",
        description: [
          "Developed and implemented reusable components for user-centric UI features across various devices using React, in collaboration with UX and Technical teams, improving user experience and code efficiency.",
          "Developed advanced features in a .NET environment using C#, which streamlined the report generation process on the platform by 25%. Optimized data processing logic and enhanced backend operations, resulting in faster and more reliable report delivery for clients.",
          "Actively contributed to creating and maintaining technical documentation, ensuring clarity, and supporting effective project management."
        ],
        technologies: ["Python", "React.js", "JavaScript", "C#", ".NET", "Docker"]
      }
    ]
  },
  {
    company: "Paddy Power",
    location: "Ireland",
    positions: [
      {
        title: "Data Analyst",
        period: "Aug 2018 - Apr 2019",
        description: [
          "Collected, cleaned, and validated datasets from multiple sources to ensure data integrity and readiness for analysis.",
          "Analyzed structured and unstructured data using Excel and SQL to identify trends and support business decision-making.",
          "Created interactive dashboards and data visualizations using tools like Power BI / Tableau to communicate insights effectively to cross-functional teams.",
          "Collaborated with marketing, sales, and operations departments to deliver ad-hoc reports and address data needs.",
          "Wrote and optimized SQL queries to extract meaningful insights from large datasets, improving reporting efficiency."
        ],
        technologies: ["SQL", "Excel", "Power BI", "Tableau", "Data Analysis", "Data Visualization"]
      }
    ]
  }
];
